import { useDispatch } from 'react-redux'
import React, { memo, useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { CustomerDocusignCompleteSigning } from 'src/constants/actionTypes'
import { ROUTES } from 'src/constants/routes'
import { useQuery } from 'src/utils/hooks/useQuery'
import { createAsyncAction } from 'src/utils/reduxUtils'
import { showToast } from 'src/utils/toast'
import { logger } from 'src/utils/logger'
import { FullScreenLoader } from 'src/components/shared/FullScreenLoader'

const CompleteGigsafeSigningPageComponent = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { getQuery } = useQuery()

  const docusignReturnEvent = getQuery('event')

  const handleCompleteSigning = useCallback(async () => {
    try {
      await createAsyncAction(dispatch, CustomerDocusignCompleteSigning.request())

      showToast('Contract signing successful', {
        variant: 'success',
      })
    } catch (err) {
      logger.track('onboarding_signing_failed')
      showToast('Failed to finish signing, please try again later', {
        variant: 'error',
      })
    }

    navigate(ROUTES.CUSTOMER_ONBOARDING_URL)
  }, [])

  useEffect(() => {
    if (docusignReturnEvent !== 'signing_complete') {
      return
    }

    handleCompleteSigning()
  }, [docusignReturnEvent, handleCompleteSigning])

  return (
    <div data-testid="customer-account-complete-gigsafe-signing-page">
      <FullScreenLoader />
    </div>
  )
}

export const CompleteGigsafeSigningPage = memo(CompleteGigsafeSigningPageComponent)
